module.exports = __webpack_public_path__ + "static/img/logo.1d8f26fb.png";